import { render, staticRenderFns } from "./dj-pagination.vue?vue&type=template&id=9c5b3fa2&scoped=true&"
import script from "./dj-pagination.vue?vue&type=script&lang=js&"
export * from "./dj-pagination.vue?vue&type=script&lang=js&"
import style0 from "./dj-pagination.vue?vue&type=style&index=0&id=9c5b3fa2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c5b3fa2",
  null
  
)

export default component.exports